import React from 'react'

import CircularProgress from '@mui/material/CircularProgress'

import './CustomButton.scss'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getClassNameForLanguage } from 'utils/common'

interface ICustomButton {
    design:
        | 'primary'
        | 'secondary'
        | 'cancel'
        | 'delete'
        | 'disabled'
        | 'grey'
        | 'accept'
        | 'reject'
        | 'white'
        | 'activation'
    type?: 'button' | 'submit'
    size?: 'small' | 'medium' | 'large'
    loading?: boolean
    disabled?: boolean
    children: React.ReactNode
    handleClick?: (evt: React.MouseEvent) => void
    onKeyPress?: () => void
    notification?: string | number
    stackClassName?: string
    productTourId?: string
    isActive?: boolean
}

export const CustomButton = ({
    design,
    type,
    size,
    disabled,
    children,
    loading,
    handleClick,
    onKeyPress,
    notification,
    stackClassName,
    productTourId,
    isActive,
    ...props
}: ICustomButton): React.ReactElement => {
    const { i18n } = useTranslation(['featuresPopup'])

    const classes = [
        `custom-button ${getClassNameForLanguage({
            i18n,
            uk: 'uk-bold',
            eng: 'eng-bold',
        })}`,
        `custom-button-design--${design}${
            design === 'activation' ? (isActive ? '--active' : '') : ''
        }`,
        `custom-button-size--${size}`,
    ]

    return (
        <div
            className={`${stackClassName} custom-button__wrapper `}
            id={productTourId}
        >
            <button
                {...props}
                // TODO
                // eslint-disable-next-line react/button-has-type
                type={type}
                disabled={loading || disabled}
                className={classes.join(' ')}
                onClick={handleClick}
                onKeyPress={onKeyPress}
            >
                {loading ? (
                    <CircularProgress
                        color={design === 'primary' ? 'primary' : 'secondary'}
                        size='22px'
                    />
                ) : (
                    children
                )}
            </button>
            {notification && (
                <Stack
                    position='absolute'
                    alignSelf='flex-end'
                    width='22px'
                    fontSize='14px'
                    padding='2px'
                    height='22px'
                    borderRadius='50%'
                    className='acrom-bold'
                    color='#ffffff'
                    alignItems='center'
                    justifyContent='center'
                    style={{ backgroundColor: '#E22C2C' }}
                    top='-5px'
                    right='-5px'
                >
                    {notification}
                </Stack>
            )}
        </div>
    )
}

CustomButton.defaultProps = {
    type: 'button',
    size: 'medium',
    loading: false,
    disabled: false,
    handleClick: undefined,
}

export default CustomButton
